import React from 'react';
import StyledToastContainer from './styles';

const Toast: React.FC = () => (
  <StyledToastContainer
    position='bottom-right'
    autoClose={5000}
    icon={false}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
  />
);

export default Toast;
